import React, {useContext, useEffect, useState} from 'react';
import {WMSContext} from "../context/WMSContext";
import {getWMSPickingMissionModels} from "../../../api/wms/wmsTaskModel/list";
import {Card, CardContent, Grid} from "@mui/material";
import Header from "./components/Header";
import WmsDesktopLayout from "../wmsDesktopLayout";
import {FormattedMessage} from "react-intl";
import PageTitle from "../../../components/WMS/Mobile/PageTitle";
import update from "../../../api/wms/wmsTaskModel/update"
import ModelItem from "./components/ModelItem";
import DeleteMissionModelModal from "./components/DeleteMissionModelModal";
import {deleteModel} from "../../../api/wms/wmsTaskModel/delete";
import CustomButton from "../../../components/CustomButton";
import {WMSRoutes} from "../../../utils/WMSRoutes";
import {useHistory, useLocation} from "react-router-dom";
import Toast from "../../../components/WMS/Toast";
import {ReactComponent as ValidIcon} from "assets/img/validated.svg"
import {Authorizations} from "../../../utils/authorizations";

MissionIndex.propTypes = {};

function MissionIndex() {
    const {currentInventory, currentMemberAuthorizations} = useContext(WMSContext)

    const [missionModels, setMissionModels] = useState([])
    const [selectedModel, setSelectedModel] = useState()
    const [openDeleteMissionModelModal, setOpenDeleteMissionModelModal] = useState(false)
    const [openValidModificationToast, setOpenValidModificationToast] = useState(false)
    const [loading, setLoading] = useState(false)

    const history = useHistory();

    const location = useLocation()
    const hasBeenModified = location.action === "PUSH" ? location.state?.hasChanged : null

    const init = () => {
        getWMSPickingMissionModels(currentInventory.id).then((response) => {
            setMissionModels(response)
        })
    }

    const handlePatchModel = (missionModel, data) => {
        update(missionModel, data)
            .then((response) => {
                let tempMissionModelsArray = [...missionModels];
                const index = tempMissionModelsArray.findIndex(model => model.id === missionModel.id);
                if (index !== -1) {
                    tempMissionModelsArray[index] = response;
                }

                setMissionModels(tempMissionModelsArray)
                setLoading(false)
            })
            .catch(() => {
                //Display error toast
            });
    }

    const handleEditeMissionModel = (missionModel) => {
        history.push(`${WMSRoutes.NEW_MISSION}/${missionModel.id}`)
    }

    const handleOpenDeleteMissionModelModal = (missionModel) => {
        setSelectedModel(missionModel)
        setOpenDeleteMissionModelModal(true)
    }

    const handleDeleteModel = () => {
        deleteModel(selectedModel).then(() => {
            setOpenDeleteMissionModelModal(false)
            init()
            setLoading(false)
        })
    }

    const handleCloseValidModificationToast = () => {
        setOpenValidModificationToast(false)
    }

    useEffect(() => {
        if (currentMemberAuthorizations && currentInventory) {
            if (!currentMemberAuthorizations.some(authorization => Authorizations.WMS_MANAGER === authorization)) {
                history.push(WMSRoutes.DASHBOARD)
                return;
            }

            init()
        }
    }, [currentInventory, currentMemberAuthorizations]);

    useEffect(() => {
        if (hasBeenModified) {
            setOpenValidModificationToast(true)
        }
    }, [hasBeenModified]);
    return (
        <WmsDesktopLayout disableScroll={true}>
            <WmsDesktopLayout.Content>
                {openDeleteMissionModelModal && (
                    <DeleteMissionModelModal
                        open={openDeleteMissionModelModal}
                        handleClose={() => setOpenDeleteMissionModelModal(false)}
                        missionModel={selectedModel}
                        loading={loading}
                        handleValid={() =>{
                            setLoading(true)
                            handleDeleteModel()
                        }}
                    />
                )}

                {openValidModificationToast && (
                    <Toast
                        open={openValidModificationToast}
                        handleClose={handleCloseValidModificationToast}
                        icon={<ValidIcon />}
                        title={<FormattedMessage id={"wms.pickingMissionList.validModificationToast.title"}/>}
                        subtitle={<FormattedMessage id={"wms.pickingMissionList.validModificationToast.subtitle"} values={{modelName: hasBeenModified}}/>}
                    />
                )}
                <Card>
                    <CardContent>
                        <Grid container sx={{maxHeight: "100%"}}>
                            <Grid container justifyContent={"space-between"} alignContent={"center"}>
                                <Grid item>
                                    <PageTitle
                                        isDesktop={true}
                                        title={<FormattedMessage id={"wms.pickingMissionList.title"}/>}
                                        subtitle={<FormattedMessage id={"wms.pickingMissionList.subtitle"}/>}
                                    />
                                </Grid>

                                <Grid item sx={{marginTop: "8px"}}>
                                    <CustomButton thicker onClick={() => history.push(`${WMSRoutes.NEW_MISSION}`)}>
                                        <FormattedMessage id={"wms.pickingMissionList.redirectButton.newModel"}/>
                                    </CustomButton>
                                </Grid>
                            </Grid>

                            <Grid container direction={"column"} sx={{marginTop: "48px"}}>
                                <Header/>
                                <Grid container sx={{overflowY: "auto", maxHeight: "70vh"}}>
                                    {missionModels.length > 0 && missionModels.map((missionModel) => {
                                        return (
                                            <ModelItem
                                                key={missionModel.id}
                                                missionModel={missionModel}
                                                loading={loading}
                                                setLoading={setLoading}
                                                handlePatchModel={handlePatchModel}
                                                handleEditMissionModel={handleEditeMissionModel}
                                                handleDeleteMissionModel={handleOpenDeleteMissionModelModal}
                                            />
                                        )
                                    })}
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </WmsDesktopLayout.Content>
        </WmsDesktopLayout>
    );
}

export default MissionIndex;